import React from "react";

interface UnsavedChangesModalProps {
    open: boolean;
    onClose: () => void;
    themeBox: boolean;
    onSave: () => void;
    onDiscard: () => void;
    isSaving?: boolean;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
    open,
    onClose,
    themeBox,
    onSave,
    onDiscard,
    isSaving = false,
}) => {
    if (!open) return null;

    return (
        <div
            className={`fixed inset-0 z-[100] flex items-center justify-center p-4 ${themeBox ? "bg-black/60" : "bg-black/40"
                }`}
        >
            <div
                className={`relative w-full max-w-md rounded-2xl shadow-xl border ${themeBox
                        ? "bg-[#1E1E1E] text-gray-100 border-[#2C2C2C]"
                        : "bg-white text-gray-900 border-gray-200"
                    }`}
            >
                <button
                    onClick={onClose}
                    aria-label="Close"
                    className={`absolute top-3 right-3 p-2 rounded-full ${themeBox ? "hover:bg-white/10" : "hover:bg-black/5"
                        }`}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M18.3 5.71 12 12l6.3 6.29-1.41 1.42L10.59 13.4 4.29 19.7 2.88 18.29 9.17 12 2.88 5.71 4.29 4.3l6.3 6.29 6.29-6.29z" />
                    </svg>
                </button>

                <div className="px-6 py-6 text-center">
                    <div
                        className={`mx-auto mb-3 flex items-center justify-center w-12 h-12 rounded-full ${themeBox ? "bg-[#111111]" : "bg-gray-100"
                            }`}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#C6D92C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <h3 className="text-lg font-semibold mb-2">Save Changes?</h3>
                    <p className={`${themeBox ? "text-gray-300" : "text-gray-600"} mb-6`}>
                        You have unsaved changes. Do you want to save them before switching, or discard them?
                    </p>

                    <div className="flex flex-row gap-2 items-center justify-center">
                        <button
                            type="button"
                            onClick={onSave}
                            className=" px-4 py-2 font-medium hover:opacity-90 text-white rounded-[10px] border"
                            style={{
                                border: "1px solid var(--menu-active-border, #C6D92C)",
                                background:
                                    "radial-gradient(94.17% 100% at 52.48% 0%, rgba(198, 217, 44, 0.80) 0%, rgba(83, 91, 16, 0.80) 100%)",
                            }}
                            disabled={isSaving}
                        >
                            {isSaving ? "Saving..." : "Save & Continue"}
                        </button>
                        <button
                            type="button"
                            onClick={onDiscard}
                            className=" px-4 py-2 font-medium hover:opacity-90 text-white rounded-[10px] border"
                    style={{
                        border: "1px solid var(--menu-active-border, #d9322c)",
                      background:
                        "radial-gradient(94.17% 100% at 52.48% 0%, rgba(217, 44, 44, 0.80) 0%, rgba(91, 16, 16, 0.80) 100%)",
                    }}
                            disabled={isSaving}
                        >
                            Discard & Switch
                        </button>                       
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UnsavedChangesModal;
